import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  transformFromNumberToString,
  transformFromStringToNumber,
} from 'components/modules/Insurance/Insurance.helpers';
import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as CarReferenceSelectors from 'store/carReference/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

import { NAME } from './PriceInput.constants';
import { getDiscount, getOfferPrice } from './PriceInput.helpers';

export const usePriceInputPresenter = () => {
  const dispatch = useDispatch();

  const { [NAME]: error } = useSelector(CarInstanceSelectors.selectErrors);
  const { [NAME]: value, [CarInstanceConstants.VALUE_FIELDS.DISCOUNT_TYPE]: discountType } =
    useSelector(CarInstanceSelectors.selectValues);
  const selectedVersion = useSelector(CarReferenceSelectors.selectSelectedVersion);

  const { disabled: pageRestrict } = useDisabledFields();

  const onChange = useCallback(
    ({ [NAME]: value }) => {
      const price = transformFromStringToNumber(value);
      const discount = getDiscount({ discountType, selectedVersion });
      const offerPrice = getOfferPrice({ discount, price });

      dispatch(
        CarInstanceActions.setCarInstance({
          [NAME]: price || undefined,
          [CarInstanceConstants.VALUE_FIELDS.OFFER_PRICE]: offerPrice,
        })
      );
      dispatch(CarInstanceActions.updateErrors({ [NAME]: '' }));
    },
    [discountType, selectedVersion]
  );

  return {
    disabled: pageRestrict,
    error,
    onChange,
    value: transformFromNumberToString(value),
  };
};
